'use client';

import { posthog } from 'posthog-js';

const POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = process.env.NEXT_PUBLIC_POSTHOG_HOST;

const isPostHogEnabled =
  typeof window !== 'undefined' &&
  POSTHOG_KEY! &&
  POSTHOG_HOST! &&
  !posthog.__loaded;

if (isPostHogEnabled) {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    defaults: '2025-05-24',
    persistence: 'sessionStorage',
    autocapture: true,
    capture_pageview: false,
    opt_out_capturing_by_default: true,
    session_recording: {
      blockClass: 'ph-no-capture',
      maskTextClass: 'ph-mask',
      maskInputOptions: {
        password: true,
        email: false,
        text: false,
      },
    },
  });
}

export { posthog };
import { initLoggingEssential } from '@/lib/logger/setup.client';

export function register() {
  initLoggingEssential();
}
